import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { ReturnUrlService } from '../return-url/return-url.service';

@Injectable()
export class AuthCallbackService implements CanActivate {
    constructor(private authService: AuthService,
                private returnUrlService: ReturnUrlService) {
    }

    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): boolean {

        this.authService.handleCallback();

        // Only alter the route in the initial 'id_token' callback,
        // not for the subsequent 'access_token' callback,
        // to avoid duplicate routing events.
        if (route.fragment && route.fragment.startsWith('id_token')) {
            this.returnUrlService.navigate();
        }

        // Always returns 'false' as we never want to actually activate this route.
        // All we want to have happen is for the route to receive the external callback,
        // and to silently process the 'id_token' or 'access_token' provided.
        return false;
    }
}
